var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import redStyle from './MenuRed.scss';
import blueStyle from './MenuBlue.scss';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

var findChildIndex = function findChildIndex(children, selectedId) {
  for (var i = 0; i < children.length; i++) {
    if (children[i].id === selectedId) {
      return i;
    }
  }

  return -1;
};

var Menu = function (_React$Component) {
  _inherits(Menu, _React$Component);

  function Menu() {
    _classCallCheck(this, Menu);

    return _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).apply(this, arguments));
  }

  _createClass(Menu, [{
    key: 'getCss',
    value: function getCss() {
      if (this.props.selectedColor && this.props.selectedColor === 'blue') {
        return blueStyle;
      } else {
        return redStyle;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          items = _props.items,
          selectedId = _props.selectedId,
          _props$onSelect = _props.onSelect,
          onSelect = _props$onSelect === undefined ? function () {} : _props$onSelect;


      return React.createElement(
        'div',
        null,
        items.map(function (item) {
          return _this2._renderItem({ item: item, selectedId: selectedId, onSelect: onSelect });
        })
      );
    }
  }, {
    key: '_renderItem',
    value: function _renderItem(_ref) {
      var item = _ref.item,
          selectedId = _ref.selectedId,
          onSelect = _ref.onSelect;

      if (item.children) {
        return this._renderGroup({ item: item, selectedId: selectedId, onSelect: onSelect });
      } else {
        return this._renderSelection({ item: item, selectedId: selectedId, onSelect: onSelect });
      }
    }
  }, {
    key: '_renderGroup',
    value: function _renderGroup(_ref2) {
      var _classnames2,
          _this3 = this;

      var item = _ref2.item,
          selectedId = _ref2.selectedId,
          onSelect = _ref2.onSelect;
      var title = item.title,
          children = item.children,
          id = item.id;


      var selectedChild = findChildIndex([].concat(_toConsumableArray(children)), selectedId);
      var selected = selectedId === id || selectedChild > -1;

      var height = !selected ? 0 : children.length * 48 - 18; /* 48 is item height, 18 is last item margin */
      var top = !selected ? 0 : selectedChild * 42 || 0;

      var cn = classnames(_defineProperty({}, this.getCss().group, selected));

      var titleCn = classnames((_classnames2 = {}, _defineProperty(_classnames2, this.getCss().grouptitle, selected), _defineProperty(_classnames2, this.getCss().title, !selected), _classnames2));

      return React.createElement(
        'div',
        { className: cn, key: id },
        React.createElement(
          'div',
          { className: titleCn, onClick: function onClick() {
              return onSelect(id);
            } },
          title
        ),
        React.createElement(
          'div',
          { className: this.getCss().groupitems, style: { height: height } },
          React.createElement('div', { className: this.getCss().groupmask, style: { top: top } }),
          children.map(function (item) {
            return _this3._renderSelection({ item: item, selectedId: selectedId, onSelect: onSelect });
          })
        )
      );
    }
  }, {
    key: '_renderSelection',
    value: function _renderSelection(_ref3) {
      var _classnames3;

      var item = _ref3.item,
          selectedId = _ref3.selectedId,
          onSelect = _ref3.onSelect;
      var title = item.title,
          id = item.id;


      var cn = classnames((_classnames3 = {}, _defineProperty(_classnames3, this.getCss().title, true), _defineProperty(_classnames3, this.getCss().selected, id === selectedId), _classnames3));

      return React.createElement(
        'div',
        { className: cn, key: id, onClick: function onClick() {
            return onSelect(id);
          } },
        title
      );
    }
  }]);

  return Menu;
}(React.Component);

Menu.propTypes = {
  items: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
  selectedId: PropTypes.any,
  selectedColor: PropTypes.string
};
Menu.displayName = 'SideBar.Menu';


export default Menu;
//# sourceMappingURL=Menu.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/SideBar/Menu.js